import cache, { KEYS, TTLS } from '../../services/cache';

export function getSearchId(update = false) {
  let searchId = cache.get(KEYS.SEARCH_ID);

  if (update) {
    searchId = searchId ? searchId + 1 : 1;
    cache.set(KEYS.SEARCH_ID, searchId, { ttl: TTLS.SEARCH_ID });
  }

  return searchId;
}
